import { render, staticRenderFns } from "./ContactusHero.vue?vue&type=template&id=dbd4484a&scoped=true"
import script from "./ContactusHero.vue?vue&type=script&lang=js"
export * from "./ContactusHero.vue?vue&type=script&lang=js"
import style0 from "./ContactusHero.vue?vue&type=style&index=0&id=dbd4484a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd4484a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
